<template>
  <v-card id="tableCard" ref="tableCard">
    <TransferDialog v-if="showTransferDialog" :table="table" :show="showTransferDialog" :item="transferDialogProperties.item"
                    @close="showTransferDialog = false"></TransferDialog>
    <v-card-title>
      <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table dense :headers="headers" :items="nfts" :items-per-page="50" :loading="moreToLoad" :loading-text="'Loading... Please wait'"
                  :search="search" :footer-props="{'items-per-page-options': [10, 50, 100, 1000, -1]}" multi-sort>

      <template v-slot:item.sendButton="{ item }">
        <td>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small @click="openTransferDialog(item)" v-bind="attrs" v-on="on">
                <v-icon>mdi-send</v-icon>
              </v-btn>
            </template>
            <span>Transfer {{item._id}}</span>
          </v-tooltip>
        </td>
      </template>

    </v-data-table>
  </v-card>
</template>

<script>
import TransferDialog from "../../../mixins/TransferDialog";

export default {
  name: 'DCROPSInventoryTable',
  components: {TransferDialog},
  props: {
    username: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.loadAll();
  },
  computed: {
    // TODO: Expand to multiples
    transferDialogProperties() {
      if (this.selectedNfts.length === 0) {
        return {
          item: {
            _id: 0
          },
        }
      }
      else {
        return {
          item: this.selectedNfts[0],
        }
      }
    }
  },
  data() {
    return {
      nfts: [],
      selectedNfts: [],
      moreToLoad: false,
      table: "DCROPS",
      showTransferDialog: false,
      headers: [
        {
          value: "_id",
          filterable: true,
          text: "ID"
        },
        {
          value: "account",
          filterable: true,
          text: "Owner"
        },
        {
          value: "properties.name",
          filterable: true,
          text: "Name"
        },
        {
          value: "type",
          filterable: true,
          text: "Type"
        },
        {
          value: "edition",
          filterable: true,
          text: "Edition"
        },
        {
          value: "rarity",
          filterable: true,
          text: "Rarity"
        },
        {
          value: "shares",
          filterable: true,
          text: "Shares"
        },
        {
          value: "season",
          filterable: true,
          text: "Seasons"
        },
        {
          value: "production",
          filterable: true,
          text: "Production amount"
        },
        {
          value: "ability",
          filterable: true,
          text: "Ability"
        },
        {
          value: "secondary",
          filterable: true,
          text: "More info"
        },
        {
          value: "tertiary",
          filterable: true,
          text: "Even more info"
        },
        {
          value: "properties.boosters",
          filterable: true,
          text: "Boosters (Land)"
        },
        {
          value: "previousAccount",
          filterable: true,
          text: "Previous Owner"
        },
        {
          value: "sendButton",
          filterable: false,
          sortable: false,
          text: "Actions"
        }
      ],
      search: "",
      SEASONS: {
        0: "Spring",
        1: "Summer",
        2: "Autumn",
        3: "Winter"
      },
      ABILITIES: {
        "none": "None",
        "mlt": "Bonus Crops Chance",
        "mh": "Multiple Harvests"
      }
    }
  },
  methods: {
    async fetchTokens(contract, table, limit, offset) {
      const tokens = await this.$ssc.find(
          contract,
          table,
          {
            account: this.username
          }, limit, offset, [], (err, result) => {

            result.forEach(item => {
              this.parseDCROPSProperties(item);
              this.nfts.push(item);
            });

            return result;
          });

      if (tokens.length === 1000) {
        offset += 1000;
        this.moreToLoad = true;
        await this.fetchTokens(contract, table, limit, offset);
      }
      else {
        this.moreToLoad = false;
      }
    },
    loadAll() {
      this.moreToLoad = true;
      this.fetchTokens("nft", "DCROPSinstances", 1000, 0);
    },
    openTransferDialog(nft) {
      this.selectedNfts = [nft]
      this.showTransferDialog = true;
    },
    // Below are defined functions that parse the various properties of DCROPS NFTs
    parseDCROPSProperties(item) {
      this.parseNFTProperty(item);
      this.parsePrimaryProperty(item);
      this.parseSecondaryProperty(item);
      this.parseTertiaryProperty(item);
    },
    parseNFTProperty(nft) {
      const props = JSON.parse(nft.properties.nft);
      nft.edition = props.edition;
      nft.rarity = props.rarity;
    },
    parsePrimaryProperty(nft) {
      // TODO: Work here
      const primary = JSON.parse(nft.properties.primary);
      nft.shares = primary.sp;
      nft.season = []
      if (primary.s) {
        primary.s.forEach(season => {
          nft.season.push(this.SEASONS[season]);
        });
      }
      nft.production = primary.qty;
      // TODO: Could add hovering here later wheer the ability gets explained
      nft.ability = this.ABILITIES[primary.ability] ? this.ABILITIES[primary.ability] : primary.ability;
      nft.type = primary.type;
    },
    // Call after parsePrimaryProperty to have the nft.type property set
    parseSecondaryProperty(nft) {
      // Some beta cards dont have secondary props. Recipes?
      if (!nft.properties.secondary) {
        nft.secondary = "-";
        return;
      }
      const secondary = JSON.parse(nft.properties.secondary);
      if (nft.type === "SEED") {
        nft.secondary = "Last used: " + new Date(secondary.cd * 1000).toLocaleString();
      } else if (nft.type === "LAND") {
        if (secondary.p && secondary.p.length > 0) {
          nft.secondary = "Planted: " + secondary.p.join(', ');
        }
        else {
          nft.secondary = "Planted: Nothing"
        }
      } else {
        nft.secondary = "-";
      }
    },
    // Call after parsePrimaryProperty to have the nft.type property set
    parseTertiaryProperty(nft) {
      if (!nft.properties.tertiary) {
        nft.tertiary = "-";
        return;
      }
      const tertiary = JSON.parse(nft.properties.tertiary);
      if (nft.type === "LAND") {
        if (tertiary.t && tertiary.t.length > 0) {
          nft.tertiary = "Planted on: ";
          nft.tertiary += tertiary.t.map((time) => new Date(time * 1000).toLocaleString()).join('; ');
        } else {
          nft.tertiary = "-";
        }
      }
      else if (nft.type === "EQP") {
        // TODO: Implement
      }
      else {
        nft.tertiary = "-";
      }
    }
  }
}
</script>